import React, { useEffect, useState } from "react";
import "./PracticeModeProgressBar.css";
import images from "../../../../../utilities/images/images";

const PracticeModeProgressBar = ({
  totalQuestions,
  streak,
  currentQuestionIndex,
  allQuestionsAttempted,
}) => {
  const progress = streak?.progress || []; // may be empty
  const maxStreak = streak?.maxStreak;
  const message = streak?.progressive_message;
  const [activeMessage, setActiveMessage] = useState(null);
  const [showMessage, setShowMessage] = useState(false);

  // Hide message instantly when user moves to another question.
  useEffect(() => {
    setShowMessage(false);
  }, [currentQuestionIndex]);

  useEffect(() => {
    if (!message) {
      setShowMessage(false);
      return;
    }

    setActiveMessage(message);
    setShowMessage(true);

    const t = setTimeout(() => {
      setShowMessage(false);
    }, 3000);

    return () => clearTimeout(t);
  }, [message?.text, message?.bg_colour, message?.emoji]);

  return (
    <div className="practice-progress-container">
      {/* Header */}
      <div className="practice-progress-header">
        <span className="practice-progress-title">Your Streak</span>
        <span className="practice-progress-count">
          {maxStreak?.count || 0} in a Row <img src={images.streakfire_icon} alt="fire"className="streak-fire-icon" />
        </span>
      </div>

      {/* Progress Bar */}
      <div className="practice-progress-bar">
        {Array.from({ length: totalQuestions }).map((_, index) => {
          let status = "empty";

          if (index < progress.length) {
            status = progress[index] ? "correct" : "wrong";
          } else if (allQuestionsAttempted) {
            // If user attempted every question, show full bar.
            status = "wrong";
          }

          return (
            <span
              key={index}
              className={`practice-progress-segment ${status}`}
            />
          );
        })}
      </div>

      {/* Message (only after save) */}
      {showMessage && activeMessage && (
        <div
          className="practice-progress-message"
          style={{ backgroundColor: activeMessage.bg_colour }}
        >
          <span className="emoji">{activeMessage.emoji}</span>
          <span className="text">{activeMessage.text}</span>
        </div>
      )}

      {/* Side popup bird */}
      <div className="practice-progress-side-bird-container">
        <img
          src={images.bird_icon}
          alt="streak"
          className={`practice-progress-side-bird ${
            showMessage ? "enter" : ""
          }`}
        />
      </div>
    </div>
  );
};

export default PracticeModeProgressBar;
